
import { mapGetters } from 'vuex';
import generateDefImageIcon from '~/mixins/generate-def-image-icon';

export default {
    mixins: [generateDefImageIcon],
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            footerSettings: 'footer/footerSettings',
            contacts: 'contacts/getShopsContacts',
            mainPhoneNumber: 'global/mainPhoneNumber',
            mainEmail: 'global/getMainEmail',
            isCasaDelTabaco: 'global/getIsCasaDelTabaco',
            developer: 'footer/getDeveloper',
            filteredSocialMediaLinks: 'global/getFilteredSocialMediaLinksForFooter',
        }),
        telegramSocialLink() {
            return this.globalSettings?.social_media?.find(social => social.key.slug === 'telegram') || null;
        },
        viberSocialLink() {
            return this.globalSettings?.social_media?.find(social => social.key.slug === 'viber') || null;
        },
        isFaqLinkAllow() {
            let flag = false;

            if (this.isCasaDelTabaco) flag = true;

            return flag;
        },
        isFooterMainBlockHasContent() {
            return (
                this.footerSettings?.columns?.length ||
                this.footerSettings?.issuanceOfOnlineOrders ||
                this.viberSocialLink ||
                this.telegramSocialLink
            );
        },
    },
};
